import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use((r) => r, (err) => {
  const d = err?.response?.data?.detail;
  if (d && typeof d === "object" && !Array.isArray(d) && d.message) {
    err.response.data.detail_field = d.field;
    err.response.data.detail = d.message;
  }
  return Promise.reject(err);
});


// Duplicate-submit guard: an identical POST (same URL + JSON body) within 10s
// reuses the in-flight promise and the same Idempotency-Key, so the server
// creates at most one record. No automatic retries are ever made.
const recent = new Map();
const WINDOW_MS = 10000;
const rawPost = api.post.bind(api);
api.post = (url, data, config = {}) => {
  const isJson = data === undefined || data === null || (typeof data === "object" && !(data instanceof FormData) && !(data instanceof Blob));
  if (!isJson) return rawPost(url, data, config);
  const sig = `${url}|${JSON.stringify(data ?? null)}`;
  const now = Date.now();
  for (const [k, v] of recent) if (now - v.at > WINDOW_MS) recent.delete(k);
  const hit = recent.get(sig);
  if (hit) return hit.promise;
  const key = (window.crypto?.randomUUID?.() || `${now}-${Math.random()}`);
  const promise = rawPost(url, data, { ...config, headers: { ...(config.headers || {}), "Idempotency-Key": key } });
  recent.set(sig, { at: now, promise });
  promise.catch(() => recent.delete(sig));
  return promise;
};
